import React from 'react';
import { string } from 'prop-types';
import './TelesalesMessage.css';

function TelesalesMessage({ email }) {
  const olxpro = `https://olx.secure.force.com/olxpro/?email=${email}`;
  return (
    <div className="telesales-message">
      <p>Para poder inserir mais de um anúncio extra, solicite um upgrade do seu plano <a className="link" href={olxpro}>aqui</a>.</p>
    </div>
  );
}

TelesalesMessage.propTypes = {
  email: string.isRequired,
};

export default TelesalesMessage;
